import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AppConfig } from '@citypantry/shared-app-config';
import { AuthModule } from '@citypantry/shared-auth';

declare const zE: any;

@NgModule({
  imports: [
    CommonModule,
    AuthModule,
  ],
})
export class ChatWidgetModule {
  constructor(
    private appConfig: AppConfig,
  ) {
    if (this.appConfig.INCLUDE_ZENDESK === true) {
      zE(() => {
        zE('messenger', 'hide');
      });
    }

    // TODO WLVS-301 Set user identity with JWT
  }
}
